import type { NoticeItem } from "@/pages/notification/data";

export function NotificationList({
  items,
  selectedId,
  onOpen,
  showChevron = true,
}: {
  items: NoticeItem[];
  selectedId?: string;
  onOpen: (id: string) => void;
  /** List-row chevron; mobile-only affordance (hidden on desktop split view). */
  showChevron?: boolean;
}) {
  return (
    <div className="ntf-list" role="list">
      {items.map((n) => {
        const selected = selectedId === n.id;
        return (
          <button
            key={n.id}
            type="button"
            className={`ntf-item ${selected ? "is-selected" : ""}`}
            role="listitem"
            onClick={() => onOpen(n.id)}
          >
            <span
              className={`ntf-dot ${n.isUnread ? "is-unread" : ""}`}
              aria-label={n.isUnread ? "Unread" : "Read"}
            />
            <span className="ntf-title" title={n.title}>
              {n.title}
            </span>
            {showChevron ? (
              <span className="ntf-chevron" aria-hidden="true">
                ›
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

